import { render, staticRenderFns } from "./ApplicationChangeLog.vue?vue&type=template&id=e5490f72&"
import script from "./ApplicationChangeLog.vue?vue&type=script&lang=ts&"
export * from "./ApplicationChangeLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports